import {NgModule} from '@angular/core';
import {PaymentCardReaderModule} from "./paymentCardReader/paymentCardReader.module";

@NgModule({
    imports: [
        PaymentCardReaderModule,
    ]
})
export class PaymentModule {
}
